<template>
  <div class="context-bar">
    <div class="context-bar__selects">
      <div class="oh fl mr20">
        <div class="fl lh30">品牌：</div>
        <div class="fl">
          <a-select
            v-model:value="state.searchParams.brandId"
            style="width: 120px"
            @change="state.onContextChange()"
          >
            <a-select-option
              v-for="(item, key) in state.brands"
              :key="key"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>
      </div>

      <div class="oh fl mr20">
        <div class="fl lh30">渠道：</div>
        <div class="fl">
          <a-select
            v-model:value="state.searchParams.channelId"
            style="width: 120px"
            @change="state.onContextChange()"
          >
            <a-select-option
              v-for="(item, key) in state.channels"
              :key="key"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>
      </div>

      <div class="oh fl mr20">
        <div class="fl lh30">站点：</div>
        <div class="fl">
          <a-select
            v-model:value="state.searchParams.siteId"
            style="width: 120px"
            @change="state.onContextChange()"
          >
            <a-select-option
              v-for="(item, key) in state.sites"
              :key="key"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>
      </div>
    </div>

    <div class="context-bar__actions">
      <a-button class="mr10" @click="state.openBatchImport()">
        批量导入
      </a-button>
      <a-button type="primary" @click="state.openConfigDrawer()">
        + 新建配置
      </a-button>
    </div>
  </div>
</template>

<script>
import { inject } from 'vue'

export default {
  name: 'ContextBar',
  setup() {
    const state = inject('initState')
    return { state }
  }
}
</script>

<style lang="scss" scoped>
.context-bar {
  background: #ffffff;
  padding: 10px 20px 20px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  &__selects {
    display: flex;
    flex-direction: row;
  }
}
</style>
